module.exports = __webpack_public_path__ + "img/evaluation-all-finished.7913afd0.png";